import { ReactElement } from 'react'
import { useMatchMedia } from '../../hooks/useMatchMedia'
import { pageBreakpoints } from '../../config/pageBreakpoints'
import { WebContactScreen } from './WebContactScreen'
import { MobileContactScreen } from './MobileContactScreen'

export const ContactScreen = (): ReactElement => {
  const isMobile = useMatchMedia(`(max-width:${pageBreakpoints.md})`)

  return isMobile ? <MobileContactScreen /> : <WebContactScreen />
}
